var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 534,
    height: 608,
    viewBox: "0 0 534 608",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M533.366 50.2568C533.366 39.6867 527.753 32.4845 517.598 30.0147C480.852 20.7145 443.575 13.6548 405.972 8.87451C378.891 5.64476 351.637 2.95042 324.4 1.20601C303.259 -0.141161 282.016 0.204267 260.824 0.0488248C227.527 -0.309559 194.239 1.30527 161.133 4.88482C143.154 6.95738 125.174 8.99541 107.298 11.7243C76.9524 16.3703 46.8829 22.5016 17.0724 29.8938C6.1569 32.6054 0.750952 39.2722 0.750952 50.5849V187.789H0.647324C0.647324 230.121 0.422795 272.419 0.785495 314.768C0.801584 329.899 1.71859 345.015 3.53165 360.037C7.83223 393.353 21.9084 422.576 43.394 448.224C66.7277 475.962 93.3602 500.246 121.547 522.768C159.173 552.644 199.51 578.937 242.032 601.301C258.889 610.213 275.608 610.334 292.275 601.059C305.885 593.494 319.616 586.119 332.932 578.036C384.521 546.689 432.208 510.332 474.108 466.67C490.171 449.952 504.454 431.955 514.903 411.091C528.72 383.457 533.125 353.715 533.228 323.335C533.556 232.315 533.366 141.277 533.366 50.2568ZM93.2566 367.36H63.1871V126.7H93.2566V367.36ZM157.385 316.685H127.298V177.374H157.385V316.685ZM220.719 342.023H190.633V152.037H220.719V342.023ZM284.036 405.357H253.967V88.7029H284.036V405.357Z",
    fill: "#268334"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogo);
export default __webpack_public_path__ + "static/media/icon-logo.a34d84ab00cb45dac4b2d4574ff4ce08.svg";
export { ForwardRef as ReactComponent };